<template>
  <v-container fluid align-start ma-0 pa-2 class="epmsa320-main container-height">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle"
          :useBtnList="useBtnList"
          :customBtnList="customBtnList"
          @btnRetrieve="btnRetrieve"
          @btnPrintInvoice="btnPrintInvoice"
          @btnExcel="btnExcel"
        >
          <template v-slot:body>
            <v-row no-gutters>
              <v-col>
                <i-card-top
                  class="d-md-flex"
                  outlined
                  :useBtnList="useBtnList2"
                  @btnChange="btnChange"
                  @btnCancel="btnCancel"
                >
                  <template v-slot:body>
                    <v-row no-gutters class="center pa-2">
                      <v-col cols="8">
                        <v-row no-gutters>
                          <i-label :label="'Closing Time :'" />
                          <v-col cols="2">
                            <v-select
                              v-model="selectClsTime"
                              :items="clsTimeList"
                              return-object
                              item-text="closeTime"
                              item-value="closeTime"
                              single-line
                              outlined
                              dense
                              height="32" />
                            </v-col>

                          <i-label :label="'Invoice Div :'" class="pl-2" />
                          <v-col cols="2">
                            <v-select
                              v-model="selectInvDiv"
                              :items="invDivList"
                              return-object
                              item-text="codeName"
                              item-value="code"
                              single-line
                              outlined
                              dense
                              height="32" />
                            </v-col>

                          <i-label :label="'Steel Lot :'" class="pl-2"  v-if="selectInvDiv.code === '7'"/>
                          <v-col cols="1" v-if="selectInvDiv.code === '7'">
                            <v-select
                              v-model="stlLotList.select"
                              :items="stlLotList.items"
                              return-object
                              item-text="name"
                              item-value="cd"
                              single-line
                              outlined
                              dense
                              height="32" />
                            </v-col>
                            
                          <i-label :label="'Invoice No :'" class="pl-2" />
                          <v-col cols="1">
                            <v-text-field 
                              v-model="invoiceNo"
                              dense 
                              outlined 
                              hide-details="auto"
                              height="32"
                            />
                          </v-col>
                        </v-row>
                      </v-col>

                      <v-col cols="4">
                        <v-row no-gutters class="justify-end">
                          <i-label :label="'Old Invoice :'" />
                          <v-col cols="3">
                            <v-text-field 
                              v-model="oldInvoice"
                              dense 
                              outlined 
                              hide-details="auto"
                              height="32"
                            />
                          </v-col>
                          <i-label :label="'New Invoice :'" class="pl-2" />
                          <v-col cols="3">
                            <v-text-field 
                              v-model="newInvoice"
                              dense 
                              outlined 
                              hide-details="auto"
                              height="32"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>

            <v-row no-gutters class="pt-1">
              <v-col>
                <DxDataGrid
                  class="listBox"
                  :ref="epmsa320Ref"
                  :data-source="dataList" 
                  :remote-operations="false" 
                  :hover-state-enabled="true"
                  :allow-column-resizing="true" 
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true" 
                  :show-borders="true" 
                  :width="grid.width"
                  :show-row-lines="true" 
                  key-expr="seq" 
                  :focused-row-enabled="false"
                  :column-hiding-enabled="false" 
                  :sorting="{ mode: 'none' }"
                  :selection="{ mode: 'none' }"
                  @cellPrepared="cellPrepared"
                >
                  <DxPaging :enabled="false" />
                  <DxPager :visible="false" />
                  <DxColumn data-field="shipNo" caption="Ship No" alignment="center" :allow-editing="false"
                                        cell-template="shipNoCellTmpl" />
                  <template #shipNoCellTmpl="{ data: cellInfo }">
                    {{ cellInfo.data.seq === '1' ? cellInfo.data.shipNo : '' }}
                  </template>
                  <DxColumn data-field="porNo" caption="POR No" alignment="center" :allow-editing="false"
                                        cell-template="porNoCellTmpl" />
                  <template #porNoCellTmpl="{ data: cellInfo }">
                    {{ `${cellInfo.data.porNo}-${cellInfo.data.porSeq}` }}
                  </template>
                  <DxColumn data-field="cutNo" caption="Cutting No" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="qty" caption="Weight(Kg)" alignment="right" :allow-editing="false" data-type="number" :format="format" />
                  <DxColumn data-field="cutFeeVnd" caption="Amount(VND)" alignment="right" :allow-editing="false" data-type="number" :format="format" />
                  <DxColumn data-field="cutVatVnd" caption="VAT(VND)" alignment="right" :allow-editing="false" data-type="number" :format="format" />
                  <DxColumn data-field="cutFeeUsd" caption="Amount(USD)" alignment="right" :allow-editing="false" data-type="number" :format="format" />
                  <DxColumn data-field="cutFeeFor" caption="Amount(WON)" alignment="right" :allow-editing="false" data-type="number" :format="format" />
                  <DxColumn data-field="invoiceNo" caption="Invoice No" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="sendToAccYn" caption="Acount Close" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="lotNo" caption="LOT No" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="cutGrp" caption="Cutting Group" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="listMach" caption="Cutting Machine" alignment="center" :allow-editing="false" />
                  <DxSummary :calculate-custom-summary="invoiceNoTotal">
                    <DxTotalItem column="shipNo" summary-type="count" display-format="TOTAL" />
                    <DxTotalItem column="qty" summary-type="sum" :customize-text="totalFormat" />
                    <DxTotalItem column="cutFeeVnd" summary-type="sum" :customize-text="totalFormat" />
                    <DxTotalItem column="cutVatVnd" summary-type="sum" :customize-text="totalFormat" />
                    <DxTotalItem column="cutFeeUsd" summary-type="sum" :customize-text="totalFormat" />
                    <DxTotalItem column="cutFeeFor" summary-type="sum" :customize-text="totalFormat" />
                    <DxTotalItem show-in-column="invoiceNo" summary-type="custom" name="invoiceNoTotal" />
                  </DxSummary>
                </DxDataGrid>
              </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import notify from 'devextreme/ui/notify'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { epmsa320TimesList, epmsa320, epmsa320Xls, epmsa320Change, epmsa320Cancel } from '@/api/view/hip/A/epmsa320'
import { getNumComma } from '@/utils/common.js'
import { reportView } from '@/api/view/hip/common/common.js'

export default {
  name: 'epmsa320',
  mixins: [baseview, BaseDataGrid],
  components: {
  },
  data() {
    return {
      makerCd: this.$store.state.user.makerCd,
      userId: this.$store.state.user.userId,
      menuTitle: this.$route.meta.title.replace(/List/g, 'Control'),
      useBtnList: ['btnRetrieve', 'btnPrintInvoice', 'btnExcel'],
      customBtnList: [
        { id: 'btnPrintInvoice', text: 'Print Invoice', icon: 'print' }
      ],
      useBtnList2: ['btnChange', 'btnCancel'],
      invoiceNo: '',
      oldInvoice: '',
      newInvoice: '',
      selectInvDiv: null,
      invDivList: [],
      selectClsTime: null,
      clsTimeList: [],
      format: '#,##0.######',
      epmsa320Ref: 'epmsa320Ref',
      dataList: [],
      mergeEls: {},
      stlLotList: {
                select: { name: 'All', cd: '%' },
                items: [
                    { name: 'All', cd: '%' },
                    { name: 'K', cd: 'K' },
                    { name: 'L', cd: 'L' },
                    { name: 'Q', cd: 'Q' },
                    { name: 'J', cd: 'J' }
                ]
            },
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epmsa320Ref)
    }
  },
  methods: {
    totalFormat(e) {
      const result = this.getNumComma(e.value.toFixed(2))
      return result
    },
    getNumComma(val) {
      return getNumComma(Number(val), 2)
    },
    async init() {
      this.gridInstance.option('defaultPaging', false)

      await this.getClosingTime()
      await this.getInvoiceDiv()
    },
    async getClosingTime() {
      const param = {
        makerCd: this.makerCd
      }

      epmsa320TimesList(param).then(res => {
        this.clsTimeList = res.list

        if(this.clsTimeList.length > 0) {
          this.selectClsTime = this.clsTimeList[0]
        }
      })
    },
    async getInvoiceDiv() {
      await getCmChildCode({
        code: '',
        codegr: '',
        prtCode: 'INV_DIV',
        userFlag: 'Y'
      }).then(res => {
        this.invDivList = res.list
        this.selectInvDiv = this.invDivList[0]
      })
    },
    btnRetrieve() {
      this.oldInvoice = ''
      this.newInvoice = ''
      this.dataList = []

      const param = {
        makerCd: this.makerCd,
        invDiv: this.selectInvDiv.code.replace(/1/g, ''),
        closeTime: this.selectClsTime.closeTime,
        invoiceNo: this.invoiceNo,
        steelLot : this.stlLotList.select.cd
      }

      this.openLoading()
      epmsa320(param).then(res => {
        // console.log('epmsa320 Res', res)

        this.dataList = res.list
      }).finally(() => {
        this.endLoading()
      })
    },
    btnPrintInvoice() {
      let param = {
        as_div: this.selectInvDiv.code.replace(/1/g, ''),
        as_close_time: this.selectClsTime.closeTime,
        as_invoice_no: this.invoiceNo,
        as_maker_cd: this.makerCd,
        fileName: this.selectInvDiv.code.replace(/1/g, '') === '7' ? 'epmsa320_tbar.jrxml' : 'epmsa320.jrxml'
      }
       console.log('invoice print', param)

      this.openLoading()
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnExcel() {
      const param = {
        makerCd: this.makerCd,
        invDiv: this.selectInvDiv.code.replace(/1/g, ''),
        closeTime: this.selectClsTime.closeTime,
        invoiceNo: this.invoiceNo,
        steelLot : this.stlLotList.select.cd
      }

      this.openLoading()
      epmsa320Xls(param).
      finally(() => {
        this.endLoading()
      })
    },
    btnChange() {
      if(this.dataList.length < 1) {
        this.vToastify(this.$t('Closing Data is not found.'), 'warn')
        return
      }

      if(!this.oldInvoice) {
        this.vToastify(this.$t('Input Old invoice no.'), 'warn')
        return
      }

      if(!this.newInvoice) {
        this.vToastify(this.$t('Input New invoice no.'), 'warn')
        return
      }

      this.vToastifyPrompt(
        this.$t('Do you want to change invoice no?'),
        'info',
        async current => {
          this.openLoading()

          const param = {
            makerCd: this.makerCd,
            userId: this.userId,
            oldInvoiceNo: this.oldInvoice,
            newInvoiceNo: this.newInvoice,
            closeTime: this.selectClsTime.closeTime
          }

          // console.log('btnChange Param', param)

          epmsa320Change(param).then(async res => {
            // console.log('btnChange Res', res)

            const msg = res.body
            if(msg === 'OK') {
              notify(this.$t('Change Invoice No is completed.'), 'success', 3000)
              this.btnRetrieve()
            } else {
              this.vToastify(this.$t(`An error has been occured.<br>${msg}`), 'warn')
              return
            }
          }).finally(() => {
            this.endLoading()
          })
        },
        null,
        false
      )
    },
    btnCancel() {
      if(this.dataList.length < 1) {
        this.vToastify(this.$t('Closing Data is not found.'), 'warn')
        return
      }

      if(!this.oldInvoice) {
        this.vToastify(this.$t('Input Old invoice no.'), 'warn')
        return
      }

      this.vToastifyPrompt(
        this.$t('Do you want to change invoice no?'),
        'info',
        async current => {
          this.openLoading()

          const param = {
            makerCd: this.makerCd,
            userId: this.userId,
            oldInvoiceNo: this.oldInvoice,
            closeTime: this.selectClsTime.closeTime
          }

          // console.log('btnChange Param', param)

          epmsa320Cancel(param).then(async res => {
            // console.log('btnChange Res', res)

            const msg = res.body
            if(msg === 'OK') {
              notify(this.$t('Cancel is completed.'), 'success', 3000)
              this.btnRetrieve()
            } else {
              this.vToastify(this.$t(`An error has been occured.<br>${msg}`), 'warn')
              return
            }
          }).finally(() => {
            this.endLoading()
          })
        },
        null,
        false
      )
    },
    invoiceNoTotal(e) {
      if(e.name === 'invoiceNoTotal') {
        // console.log('e', e.value)

        if(this.dataList.length > 0) {
          switch(e.summaryProcess) {
            case 'start':
              e.totalValue = ''
              break
            case 'calculate':
                e.unitPrice = e.value.unitPrice
                e.moneUnit = e.value.moneUnit
                e.exchRateFor = e.value.exchRateFor
                e.exchRate = e.value.exchRate
                break
            case 'finalize':
                e.totalValue =
                  `Price : ${this.getNumComma(e.unitPrice)} ${e.moneUnit} / TON`
                  + `\nExchange Rate(1$) : ${this.getNumComma(e.exchRateFor)} WON, ${this.getNumComma(e.exchRate)} VND`
                break
          }
        }
      }
    },
    cellPrepared(e) {
      if(e.rowType === 'totalFooter') {
        if(e.column.dataField === 'shipNo') {
          e.cellElement.setAttribute('colspan', 3)
        } else if(e.column.dataField === 'porNo' || e.column.dataField === 'cutNo'
                      || e.column.dataField === 'sendToAccYn' || e.column.dataField === 'lotNo' || e.column.dataField === 'cutGrp') {
          e.cellElement.style.display = 'none'
        } else if(e.column.dataField === 'invoiceNo') {
          e.cellElement.setAttribute('colspan', 4)
          e.cellElement.style['white-space'] = 'pre'
          e.cellElement.querySelector('div').style.textAlign = 'left'
        }

        if(e.cellElement.getElementsByClassName('dx-datagrid-summary-item dx-datagrid-text-content')[0]) {
          e.cellElement.getElementsByClassName('dx-datagrid-summary-item dx-datagrid-text-content')[0].style.color = '#000000'
          // e.cellElement.getElementsByClassName('dx-datagrid-summary-item dx-datagrid-text-content')[0].style.fontWeight = 'bold'
        }
      }
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style>

</style>template